// extracted by mini-css-extract-plugin
export var menuColumn = "styles-module--menuColumn--x0lnN";
export var open = "styles-module--open--1Ss+1";